import { ref } from "vue";

import type { ProductConfig } from "@/types/products/product-config";

import {
    actionsColumnKey,
    articleKey,
    bonusReportKey,
    buyUnderColumnKey,
    closedColumnKey,
    closedPositionKey,
    closedPositionsTitle,
    closedStockPriceColumnKey,
    initiatedColumnKey,
    initiatedKey,
    lastCloseColumnKey,
    modelPortfolioKey,
    openedPositionKey,
    openedStockPriceColumnKey,
    openPositionsTitle,
    sectorColumnKey,
    stockGainsColumnKey,
    symbolColumnKey,
    tradeAlertKey,
    webinarKey
} from "@/types/products/product-definitions";
import { scccProductKey } from "@/types/permissions";

// Non-reactive variables
import {
    configureProductActionsMap,
    configureProductPortfolioActionsMap,
    initializeProduct
} from "@/composables/products/product-composition-helpers";

const initialView: string = modelPortfolioKey;
const selectedView = ref< string >( initialView );

const productConfig: ProductConfig = {
    slug: scccProductKey,
    modelPortfolioKeys: [
        {
            key: openedPositionKey,
            title: openPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                initiatedColumnKey,
                openedStockPriceColumnKey,
                openedStockPriceColumnKey,
                buyUnderColumnKey,
                lastCloseColumnKey,
                actionsColumnKey
            ]
        },
        {
            key: closedPositionKey,
            title: closedPositionsTitle,
            columnKeys: [
                symbolColumnKey,
                sectorColumnKey,
                initiatedColumnKey,
                closedColumnKey,
                openedStockPriceColumnKey,
                closedStockPriceColumnKey,
                stockGainsColumnKey,
                actionsColumnKey
            ]
        }
    ]
}

const productActionTopicKeys = [
    bonusReportKey,
    modelPortfolioKey,
    tradeAlertKey,
    articleKey,
    webinarKey
];

export function useSmallCapCashCows() {
    const initialized = ref< boolean >( false );

    const logoPath = ref< string | undefined >( '' );
    const darkLogoPath = ref< string | undefined >( '' );

    const actionsMap = configureProductActionsMap( scccProductKey, productActionTopicKeys );

    const portfolioActionsMap =
        configureProductPortfolioActionsMap(
            'SCCC', initiatedKey, closedPositionKey,
            productConfig.modelPortfolioKeys![ 0 ], productConfig.modelPortfolioKeys![ 1 ] );

    initializeProduct( productConfig.slug, initialized, logoPath, darkLogoPath );

    return {
        // STATE
        actionsMap,
        initialized,
        initialView,
        logoPath,
        darkLogoPath,
        portfolioActionsMap,
        selectedView
    }
}
